import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private queue: { message: string, config: MatSnackBarConfig }[] = [];
  private isShowingSnackbar = false;
  featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
  isSpinner:boolean =false

  constructor(private snackBar: MatSnackBar, private spinner: NgxSpinnerService) { }


  config: MatSnackBarConfig = {
    // duration: 3000,
    horizontalPosition: 'right',
    verticalPosition: 'top'
  }

  // Convenience methods for different message types
  success(message: string, duration: number = 0) {
    if(duration !== 0) {
      this.config['duration'] = duration;
    }
    this.config['panelClass'] = ['notification', 'success-snackbar'];
    this.snackBar.open(message, 'X', this.config);
  }

  warning(message: string, duration: number = 0) {
    if(duration !== 0) {
      this.config['duration'] = duration;
    }
    this.config['panelClass'] = ['notification', 'warning-snackbar'];
    this.snackBar.open(message, 'X', this.config);
  }
  warningMsg(message: string, duration: number = 0) {
    if(duration !== 0) {
      this.config['duration'] = duration;
    }
    this.config['panelClass'] = ['notification', 'warning-msg-snackbar'];
    this.snackBar.open(message, 'X', this.config);
  }

  error(message: string, duration: number = 0) {
    if(duration !== 0) {
      this.config['duration'] = duration;
    }
    this.config['panelClass'] = ['notification', 'error-snackbar'];
    this.snackBar.open(message, 'X', this.config);
  }

  showSpinner(){
    this.isSpinner = true
    this.spinner.show();
  }
  hideSpinner(){
    this.isSpinner = false
    this.spinner.hide();
  }

}
